function cookiesUserId() {
    let user_id = "";
    if (getCookie("uepUserID") !== "") {
      createCookie("uepUserID", +user_id, -30);
    }
    try {
      if (localStorage && localStorage.getItem("emp-device-id") == null) {
        user_id = guid();
        localStorage.setItem("emp-device-id", user_id);
        return user_id;
      } else if (localStorage) {
        return localStorage.getItem("emp-device-id");
      } else {
        user_id = guid();
        return user_id;
      }
    } catch (e) {
      user_id = guid();
      return "private-" + user_id;
    }
  }
  
  function getCookie(c_name) {
    let c_start = 0;
    let c_end = 0;
    if (document.cookie.length > 0) {
      c_start = document.cookie.indexOf(c_name + "=");
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        c_end = document.cookie.indexOf(";", c_start);
        if (c_end == -1) {
          c_end = document.cookie.length;
        }
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return "";
  }
  
  function createCookie(name$$1, value, days) {
    let expires;
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    } else {
      expires = "";
    }
    document.cookie = name$$1 + "=" + value + expires + "; path=/";
  }
  
  function guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
  
    return (
      s4() +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      s4() +
      s4()
    );
  }
  
  export default {
    guid,
    createCookie,
    cookiesUserId,
    getCookie,
  };
  